var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 5.78801L17.0379 1.34488H14.6205V0H0V11.9308H2.01949C2.01855 11.9596 2.0173 11.9883 2.0173 12.0173C2.0173 13.4527 3.18512 14.6205 4.62059 14.6205C6.05606 14.6205 7.22383 13.4527 7.22383 12.0173C7.22383 11.9883 7.22258 11.9596 7.22164 11.9308H12.7785C12.7775 11.9596 12.7763 11.9883 12.7763 12.0173C12.7763 13.4527 13.9441 14.6205 15.3795 14.6205C16.815 14.6205 17.9828 13.4527 17.9828 12.0173C17.9828 11.9883 17.9816 11.9596 17.9806 11.9308H20V5.78801ZM16.4107 2.51676L18.3192 5.37949H14.6205V2.51676H16.4107ZM13.4487 1.17188V6.72434H1.17188V1.17188H13.4487ZM4.62055 13.4487C3.83129 13.4487 3.18914 12.8066 3.18914 12.0173C3.18914 11.228 3.83125 10.5859 4.62055 10.5859C5.40984 10.5859 6.05191 11.228 6.05191 12.0173C6.05191 12.8066 5.4098 13.4487 4.62055 13.4487ZM6.89844 10.7589C6.4541 9.95777 5.59977 9.41406 4.62055 9.41406C3.64133 9.41406 2.78699 9.95777 2.34262 10.7589H1.17188V7.89621H13.4487V10.2732C13.3152 10.4208 13.1987 10.5838 13.1016 10.7589H6.89844ZM15.3795 13.4487C14.5902 13.4487 13.9481 12.8066 13.9481 12.0173C13.9481 11.228 14.5902 10.5859 15.3795 10.5859C16.1687 10.5859 16.8109 11.228 16.8109 12.0173C16.8109 12.8066 16.1687 13.4487 15.3795 13.4487ZM17.6574 10.7589C17.213 9.95777 16.3587 9.41406 15.3795 9.41406C15.1155 9.41406 14.8608 9.45383 14.6205 9.52719V6.55133H18.8281V10.7589H17.6574V10.7589Z",
    fill: "#677489"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.03467 11.4312H5.20654V12.603H4.03467V11.4312Z",
    fill: "#677489"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7935 11.4312H15.9653V12.603H14.7935V11.4312Z",
    fill: "#677489"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.ad62f50eaf2cc48151f8727da8d30b87.svg";
export { ForwardRef as ReactComponent };